import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { citaService, pagoService } from '../services/api';
import './MisCitas.css';

function MisCitas() {
  const navigate = useNavigate();
  const [citas, setCitas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [citaSeleccionada, setCitaSeleccionada] = useState(null);
  const [usuario, setUsuario] = useState(null);

  useEffect(() => {
    const usuarioActual = JSON.parse(localStorage.getItem('usuarioActual') || 'null');
    
    if (!usuarioActual) {
      alert('Debes iniciar sesión para ver tus citas');
      navigate('/login');
      return;
    }
    
    setUsuario(usuarioActual);
    cargarCitas(usuarioActual.id);
  }, [navigate]);

  const cargarCitas = async (usuarioId) => {
    try {
      setLoading(true);
      setError(null);
      
      const citasData = await citaService.obtenerPorUsuario(usuarioId);
      console.log('✅ Citas cargadas:', citasData);
      
      setCitas(citasData);
    } catch (err) {
      console.error('❌ Error al cargar citas:', err);
      setError('Error al cargar tus citas');
    } finally {
      setLoading(false);
    }
  };

  const obtenerColorEstado = (estado) => {
    switch(estado) {
      case 'CONFIRMADO':
      case 'PAGADA': return '#4CAF50';
      case 'PENDIENTE': return '#ff9800';
      case 'CANCELADO': return '#f44336';
      case 'COMPLETADO': return '#2196F3';
      default: return '#666';
    }
  };

  const obtenerTextoEstado = (estado) => {
    switch(estado) {
      case 'CONFIRMADO': return '✅ Confirmada';
      case 'PAGADA': return '✅ Pagada';
      case 'PENDIENTE': return '⏳ Pendiente de Pago';
      case 'CANCELADO': return '❌ Cancelada';
      case 'COMPLETADO': return '✔️ Completada';
      default: return estado;
    }
  };

  const enviarWhatsApp = (cita) => {
    if (!cita.telefonoChica) {
      alert('El contacto se desbloqueará una vez confirmado el pago');
      return;
    }

    const mensaje = encodeURIComponent(
      `Hola ${cita.nombreChica}, soy ${usuario.nombreCompleto}.\n\n` +
      `Tengo una cita confirmada:\n` +
      `📅 Fecha: ${cita.fecha}\n` +
      `⏰ Hora: ${cita.horaInicio} - ${cita.horaFin}\n` +
      `📍 Distrito: ${cita.distrito}\n` +
      `🎫 Código: ${cita.codigoCita}\n\n` +
      `¿Confirmamos los detalles?`
    );
    
    const url = `https://wa.me/51${cita.telefonoChica}?text=${mensaje}`;
    window.open(url, '_blank');
  };

  const reintentarPago = async (cita) => {
    try {
      console.log('💳 Reintentando pago para cita:', cita.id);
      
      const pagoData = {
        citaId: cita.id,
        email: usuario.email || 'cliente@kanolima.com',
        telefono: usuario.telefono || ''
      };

      const preferenciaResponse = await pagoService.crearPreferencia(pagoData);
      const urlPago = preferenciaResponse.initPoint || preferenciaResponse.sandboxInitPoint;
      
      window.open(urlPago, '_blank');
      alert('Se ha abierto Mercado Pago en una nueva pestaña.\n\nCompleta el pago para confirmar tu cita.');
    } catch (error) {
      console.error('❌ Error al reintentar pago:', error);
      alert('Error al procesar el pago: ' + error.message);
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Cargando tus citas...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-container">
        <div className="error-icon">⚠️</div>
        <h2>{error}</h2>
        <button 
          onClick={() => cargarCitas(usuario.id)}
          className="btn-retry"
        >
          Reintentar
        </button>
      </div>
    );
  }

  return (
    <div className="mis-citas-container">
      {/* Header */}
      <header className="mis-citas-header">
        <div className="container">
          <div className="header-content">
            <h1 className="logo" onClick={() => navigate('/')} style={{cursor: 'pointer'}}>
              <span className="logo-text">Novia de Alquiler</span>
              <span className="logo-brand">"Petit Kano"</span>
            </h1>
            <div className="user-info">
              <span>¡Hola, {usuario?.nombreCompleto}!</span>
              <button onClick={() => navigate('/')} className="btn-volver">
                Volver al Inicio
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <div className="mis-citas-content">
        <div className="container">
          <div className="page-header">
            <h2>📋 Mis Citas</h2>
            <p>Aquí puedes ver todas tus citas reservadas y confirmadas</p>
          </div>

          {citas.length === 0 ? (
            <div className="no-citas">
              <div className="no-citas-icon">📅</div>
              <h3>No tienes citas aún</h3>
              <p>Explora nuestro catálogo y reserva tu primera cita</p>
              <button 
                onClick={() => navigate('/')}
                className="btn-primary"
              >
                Ver Chicas Disponibles
              </button>
            </div>
          ) : (
            <div className="citas-grid">
              {citas.map((cita) => (
                <div 
                  key={cita.id} 
                  className="cita-card"
                  onClick={() => setCitaSeleccionada(cita)}
                >
                  <div className="cita-header">
                    <span 
                      className="cita-estado"
                      style={{
                        background: obtenerColorEstado(cita.estado),
                        color: 'white',
                        padding: '6px 12px',
                        borderRadius: '20px',
                        fontSize: '13px',
                        fontWeight: '600'
                      }}
                    >
                      {obtenerTextoEstado(cita.estado)}
                    </span>
                    {(cita.estado === 'PAGADA' || cita.estado === 'CONFIRMADO') && (
                      <span className="cita-codigo">{cita.codigoCita}</span>
                    )}
                  </div>

                  <div className="cita-chica">
                    <h3>{cita.nombreChica}</h3>
                    <span>{cita.edadChica} años</span>
                  </div>

                  <div className="cita-detalles">
                    <div className="detalle-row">
                      <span className="detalle-label">📅 Fecha:</span>
                      <span className="detalle-value">{cita.fecha}</span>
                    </div>
                    <div className="detalle-row">
                      <span className="detalle-label">⏰ Hora:</span>
                      <span className="detalle-value">{cita.horaInicio} - {cita.horaFin}</span>
                    </div>
                    <div className="detalle-row">
                      <span className="detalle-label">📍 Distrito:</span>
                      <span className="detalle-value">{cita.distrito}</span>
                    </div>
                    <div className="detalle-row">
                      <span className="detalle-label">💰 Total:</span>
                      <span className="detalle-value">S/ {cita.total}</span>
                    </div>
                  </div>

                  {cita.estado === 'PENDIENTE' && (
                    <button 
                      onClick={(e) => {
                        e.stopPropagation();
                        reintentarPago(cita);
                      }}
                      className="btn-pagar"
                      style={{
                        background: '#ff9800',
                        color: 'white',
                        border: 'none',
                        padding: '10px 20px',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        fontWeight: 'bold',
                        width: '100%',
                        marginTop: '10px'
                      }}
                    >
                      💳 Pagar Ahora
                    </button>
                  )}
                  {(cita.estado === 'CONFIRMADO' || cita.estado === 'PAGADA') && cita.telefonoChica && (
                    <button 
                      onClick={(e) => {
                        e.stopPropagation();
                        enviarWhatsApp(cita);
                      }}
                      className="btn-whatsapp"
                    >
                      💬 Contactar por WhatsApp
                    </button>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Modal de Detalle */}
      {citaSeleccionada && (
        <div className="modal-overlay" onClick={() => setCitaSeleccionada(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button 
              className="modal-close"
              onClick={() => setCitaSeleccionada(null)}
            >
              ✕
            </button>

            <h2>📋 Detalle de la Cita</h2>

            <div className="modal-body">
              {(citaSeleccionada.estado === 'PAGADA' || citaSeleccionada.estado === 'CONFIRMADO') && (
                <div className="modal-section">
                  <h3>Código de Cita</h3>
                  <div className="codigo-display">
                    {citaSeleccionada.codigoCita}
                  </div>
                </div>
              )}

              <div className="modal-section">
                <h3>Información de la Cita</h3>
                <div className="info-grid">
                  <div className="info-item">
                    <span className="info-label">Con:</span>
                    <span className="info-value">{citaSeleccionada.nombreChica}</span>
                  </div>
                  <div className="info-item">
                    <span className="info-label">Fecha:</span>
                    <span className="info-value">{citaSeleccionada.fecha}</span>
                  </div>
                  <div className="info-item">
                    <span className="info-label">Hora:</span>
                    <span className="info-value">{citaSeleccionada.horaInicio} - {citaSeleccionada.horaFin}</span>
                  </div>
                  <div className="info-item">
                    <span className="info-label">Distrito:</span>
                    <span className="info-value">{citaSeleccionada.distrito}</span>
                  </div>
                  <div className="info-item">
                    <span className="info-label">Duración:</span>
                    <span className="info-value">{citaSeleccionada.horas} hora(s)</span>
                  </div>
                  <div className="info-item">
                    <span className="info-label">Total:</span>
                    <span className="info-value" style={{fontWeight: 'bold', color: '#e91e63'}}>
                      S/ {citaSeleccionada.total}
                    </span>
                  </div>
                  <div className="info-item">
                    <span className="info-label">Estado:</span>
                    <span className="info-value" style={{
                      color: obtenerColorEstado(citaSeleccionada.estado),
                      fontWeight: 'bold'
                    }}>
                      {obtenerTextoEstado(citaSeleccionada.estado)}
                    </span>
                  </div>
                </div>
              </div>

              {(citaSeleccionada.estado === 'CONFIRMADO' || citaSeleccionada.estado === 'PAGADA') && citaSeleccionada.telefonoChica && (
                <div className="modal-section contacto-section">
                  <h3>📞 Contacto Desbloqueado</h3>
                  <div className="telefono-display">
                    {citaSeleccionada.telefonoChica}
                  </div>
                  <button 
                    onClick={() => enviarWhatsApp(citaSeleccionada)}
                    className="btn-whatsapp-modal"
                  >
                    💬 Abrir WhatsApp
                  </button>
                </div>
              )}

              {citaSeleccionada.estado === 'PENDIENTE' && (
                <div className="modal-section alert-section">
                  <p style={{color: '#ff9800', textAlign: 'center', lineHeight: '1.6', marginBottom: '15px'}}>
                    ⚠️ Esta cita está pendiente de pago.
                    <br/>
                    El contacto se desbloqueará una vez confirmado el pago.
                  </p>
                  <button 
                    onClick={() => reintentarPago(citaSeleccionada)}
                    style={{
                      background: '#ff9800',
                      color: 'white',
                      border: 'none',
                      padding: '12px 30px',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      fontWeight: 'bold',
                      fontSize: '16px',
                      width: '100%'
                    }}
                  >
                    💳 Pagar Ahora
                  </button>
                </div>
              )}

              {citaSeleccionada.estado === 'CANCELADO' && (
                <div className="modal-section alert-section">
                  <p style={{color: '#f44336', textAlign: 'center', lineHeight: '1.6'}}>
                    ❌ Esta cita fue cancelada.
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default MisCitas;